import z from 'zod';

import {
    decodeHeadingVariants,
    encodeHeadingVariants,
    PlateHeadingVariant,
    UnityHeadingVariant,
} from './HeadingVariants';
import { PlateTextElements, TextElementsCodec, UnityTextElements } from './Text';
import { CURRENT_VERSION, ElementId, UnityElementId, Version } from '../commons';
import { ELEMENT_TYPES } from '../constants';

export const UnityLead = z.object({
    type: z.literal(ELEMENT_TYPES.LEAD),
    elementId: UnityElementId,
    templateElement: z.boolean().optional(),
    version: Version,
    items: UnityTextElements,
    variants: z.record(z.string(), UnityHeadingVariant).optional(),
});
export type UnityLead = z.infer<typeof UnityLead>;

export const PlateLead = z.object({
    type: z.literal(ELEMENT_TYPES.LEAD),
    id: ElementId,
    data: z
        .object({
            templateElement: z.boolean().optional(),
        })
        .optional(),
    children: PlateTextElements,
    variants: z.record(z.string(), PlateHeadingVariant).optional(),
});
export type LeadElement = z.infer<typeof PlateLead>;

export const LeadCodec = z.codec(UnityLead, PlateLead, {
    decode: (value) => ({
        type: value.type,
        id: value.elementId ?? crypto.randomUUID(),
        ...(value.templateElement ? { data: { templateElement: value.templateElement } } : {}),
        children: TextElementsCodec.decode(value.items),
        ...(value.variants ? { variants: decodeHeadingVariants(value.variants) } : {}),
    }),
    encode: (value) => ({
        type: value.type,
        elementId: value.id,
        version: CURRENT_VERSION,
        items: TextElementsCodec.encode(value.children),
        ...value.data,
        ...(value.variants ? { variants: encodeHeadingVariants(value.variants) } : {}),
    }),
});
